<template>
    <div class="meetingplan-edit">
        <div class="fields">
            <div class="field-block">
                <div class="field-row" :class="required('meetingName', true)">
                    <div class="field-input-no-title">会议名称<span>*</span></div><mt-field :attr="{ maxlength: 50 }" class="align-right" label="" placeholder="请输入会议名称" v-model="addNewOrEditData.meetingName"></mt-field>
                </div>
            </div>
            <div class="field-block">
                <div class="field-row" :class="required('meetingSystem', true)">
                    <common-select-multiple tipCode="8" ref="meetingSystem" required clearable alignRight title="系统选择" placeholder="请选择（可多选）" v-model="addNewOrEditData.meetingSystem"  :datas="baseDataRecords.MeetingSystem" :textKey="'text'" :valueKey="'value'">
                    </common-select-multiple>
                </div>
                <div class="field-row" :class="required('meetingModality', true)">
                    <common-select required clearable alignRight title="是否网络会议" placeholder="请选择" v-model="addNewOrEditData.meetingModality"  :datas="baseDataRecords.MeetingModality" :textKey="'text'" :valueKey="'value'">
                    </common-select>
                </div>
                <div class="field-row" :class="required('meetingProp', true)">
                    <common-select @change="handleMeetingPropChange()" required clearable alignRight title="会议性质" placeholder="请选择" v-model="addNewOrEditData.meetingProp"  :datas="meetingPropAndTypeArrays.selectMeetingProp" :textKey="'itemText'" :valueKey="'itemValue'">
                    </common-select>
                </div>
                <div class="field-row" :class="required('meetingType', meetingSystemType != 'GSD')" v-show="meetingSystemType != 'GSD'">
                    <common-select @change="handleMeetingTypeChange" required clearable alignRight title="A1会议类型" placeholder="请选择" v-model="addNewOrEditData.meetingType"  :datas="filterMeetingType" :textKey="'itemText'" :valueKey="'itemValue'">
                    </common-select>
                </div>
                <div v-show="addNewOrEditData.meetingType == '24' && isCEDepart()">
                    <div class="field-title" :class="required('isGsd', addNewOrEditData.meetingType == '24' && isCEDepart())">是否为GSD<span>*</span></div>
                    <div class="field-row">
                        <mt-radio
                        title=""
                        class="radio"
                        v-model="addNewOrEditData.isGsd"
                        :options="isGsdOptions">
                        </mt-radio>
                    </div>
                </div>
                <div class="field-row" :class="required('meetingGsdType', meetingSystemType != 'A1')" v-show="meetingSystemType != 'A1'">
                    <common-select @change="addNewOrEditData.meetingGsdSubType = ''" required clearable alignRight title="GSD项目类型" placeholder="请选择" v-model="addNewOrEditData.meetingGsdType"  :datas="baseDataRecords.MeetingGsdType" :textKey="'text'" :valueKey="'value'">
                    </common-select>
                </div>
                <div class="field-row" :class="required('meetingGsdSubType', meetingSystemType != 'A1')" v-show="meetingSystemType != 'A1'">
                    <common-select required clearable alignRight title="GSD细类" placeholder="请选择" v-model="addNewOrEditData.meetingGsdSubType"  :datas="MeetingGsdSubTypes" :textKey="'text'" :valueKey="'value'">
                    </common-select>
                </div>
            </div>
            <div class="field-block">
                <div class="field-row" :class="required('departId', true)">
                    <common-select required clearable @change="handleDepartChange" alignRight title="部门" placeholder="请选择" v-model="addNewOrEditData.departId"  :datas="baseDataRecords.Depart" :textKey="'departName'" :valueKey="'id'">
                    </common-select>
                </div>                
                <div class="field-row" :class="required('medicalField', true)">
                    <common-select required clearable @change="resetRelativeFields" alignRight title="Franchise/DA" placeholder="请选择" v-model="addNewOrEditData.medicalField"  :datas="baseDataRecords.MedicalField" :textKey="'medicalFieldName'" :valueKey="'id'">
                    </common-select>
                </div>                
                <div class="field-row" :class="required('teamL4', true)">
                    <common-select required clearable @change="resetRelativeFields" alignRight title="团队" placeholder="请选择" v-model="addNewOrEditData.teamL4"  :datas="baseDataRecords.Teams" :textKey="'teamName'" :valueKey="'id'">
                    </common-select>
                </div>                            
                <div class="field-row" :class="required('treatmentArea', basedataGetName('MeetingProp',addNewOrEditData.meetingProp) == '推广')" v-show="basedataGetName('MeetingProp',addNewOrEditData.meetingProp) == '推广'">
                    <common-select @change="handleAreaChange()" filterable required clearable alignRight title="治疗领域" placeholder="请选择" v-model="addNewOrEditData.treatmentArea"  :datas="areaRelationObject[addNewOrEditData.meetingProp]" :textKey="'areaName'" :valueKey="'areaDbId'">
                    </common-select>
                </div>                              
                <div class="field-row" :class="required('diseaseArea', basedataGetName('MeetingProp',addNewOrEditData.meetingProp).indexOf('非推广') >= 0)" v-show="basedataGetName('MeetingProp',addNewOrEditData.meetingProp).indexOf('非推广') >= 0">
                    <common-select @change="handleAreaChange()" filterable required clearable alignRight title="疾病领域" placeholder="请选择" v-model="addNewOrEditData.diseaseArea"  :datas="areaRelationObject[addNewOrEditData.meetingProp]" :textKey="'areaName'" :valueKey="'areaDbId'">
                    </common-select>
                </div>    
                <div class="field-title" :class="required('productId', true)">产品(多选)<span>*</span></div>
                <div class="field-row" :class="required('productId', true)">
                    <common-select-multiple filterable clearable @change="resetRelativeFields" title="" placeholder="请选择" v-model="addNewOrEditData.productId"  :datas="productArray" :textKey="'productName'" :valueKey="'productDbId'">
                    </common-select-multiple>
                </div> 
                <div class="field-title" :class="required('companyStrategy', true)">公司战略(多选)<span>*</span></div>    
                <div class="field-row" :class="required('companyStrategy', true)">
                    <common-select-multiple  clearable title="" placeholder="请选择" v-model="addNewOrEditData.companyStrategy"  :datas="baseDataRecords.CompanyStrategy" :textKey="'text'" :valueKey="'value'">
                    </common-select-multiple>
                </div>     
                <div class="field-title" :class="required('strategyKeynote', true)">策略重点(多选)<span>*</span></div>
                <div class="field-row">
                    <common-select-multiple filterable clearable ref="strategy" title="" placeholder="请选择" v-model="addNewOrEditData.strategyKeynote" :datas="baseDataRecords.filterStrategy" :includeDatas="[{'id':'999999','productNameAndKeynote':'其他/不适用'}]" :textKey="'productNameAndKeynote'" :valueKey="'id'">
                    </common-select-multiple>
                </div>    
                <div class="field-title" :class="required('medicalFieldResult', meetingSystemType != 'A1')">治疗领域业务结果(多选)<span>*</span></div>
                <div class="field-row">
                    <common-select-multiple filterable clearable ref="domainResult" title="" placeholder="请选择" v-model="addNewOrEditData.medicalFieldResult"  :datas="baseDataRecords.filterDomainResult" :textKey="'productNameAndTreatAreaResult'" :valueKey="'id'" :includeDatas="[{'id':'999999','productNameAndTreatAreaResult':'其他'}]">
                    </common-select-multiple>
                </div>    
                <div v-show="addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') >= 0" class="field-title">治疗领域业务结果（自定义描述）</div>
                <div v-show="addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') >= 0" class="field-row">
                    <mt-field :attr="{ maxlength: 200 }" placeholder="请输入治疗领域业务结果自定义描述，最多可输入200字" type="textarea" v-model="addNewOrEditData.medicalFieldResultDes"></mt-field>
                </div>
            </div>
            <div class="field-block">
                <div class="field-row" :class="required('meetingBeginDate', true)">
                    <common-select-datetime required alignRight title="会议开始日期" placeholder="请选择" :pickerOptions="startPickerOptions" v-model="addNewOrEditData.meetingBeginDate"  :defaultDate="seasonStartDate"  :minDate="seasonStartDate">
                    </common-select-datetime>
                </div>                
                <div class="field-row" :class="required('meetingEndDate', true)">
                    <common-select-datetime required alignRight title="会议结束日期" placeholder="请选择" :pickerOptions="endPickerOptions" v-model="addNewOrEditData.meetingEndDate"  :defaultDate="seasonStartDate"  :minDate="seasonStartDate">
                    </common-select-datetime>
                </div> 
                <div class="field-row" :class="required('meetingTimeInt', meetingSystemType != 'GSD')">
                    <common-select :required="meetingSystemType != 'GSD'" clearable alignRight title="会议时段" placeholder="请选择" v-model="addNewOrEditData.meetingTimeInt"  :datas="baseDataRecords.MeetingTimeInt" :textKey="'text'" :valueKey="'value'">
                    </common-select>
                </div>         
                <div class="field-row" :class="required('country', meetingSystemType != 'GSD')">
                    <common-select :required="meetingSystemType != 'GSD'" @change="handleCountryChange" clearable alignRight title="国家" placeholder="请选择" v-model="addNewOrEditData.country"  :datas="baseDataRecords.Country" :textKey="'name'" :valueKey="'id'">
                    </common-select>
                </div> 
                <div class="field-row" :class="required('province', meetingSystemType != 'GSD')">
                    <common-select :required="meetingSystemType != 'GSD'" @change="handleProvinceChange" clearable alignRight title="省份" placeholder="请先选择国家" v-model="addNewOrEditData.province"  :datas="remoteProvinceData" :textKey="'name'" :valueKey="'id'">
                    </common-select>
                </div>      
                <div class="field-row" :class="required('city', meetingSystemType != 'GSD')">
                    <common-select :required="meetingSystemType != 'GSD'" @change="addNewOrEditData.cityName = getName(addNewOrEditData.city, remoteCitiesData, 'id', 'name');clearHospital()" clearable alignRight title="城市" placeholder="请先选择省份" v-model="addNewOrEditData.city"  :datas="remoteCitiesData" :textKey="'name'" :valueKey="'id'">
                    </common-select>
                </div>  
                <div class="field-row" :class="required('meetingPlace', meetingSystemType != 'GSD' && basedataGetName('MeetingModality',addNewOrEditData.meetingModality).indexOf('线下') >= 0)">
                    <div class="field-input-no-title">会议地点<span>*</span></div><mt-field :attr="{ maxlength: 50 }" class="align-right" placeholder="请输入会议地点" v-model="addNewOrEditData.meetingPlace"></mt-field>
                </div>  
                <div v-show="meetingSystemType != 'A1'"> 
                    <div class="field-row" :class="required('recipientSocietyOrHospital',meetingSystemType != 'A1',true)">
                        <common-select :required="meetingSystemType != 'A1'" alignRight title="受赠方类型" placeholder="请选择" v-model="recipientSocietyOrHospital"  :datas="recipientSocietyOrHospitalOptions" :textKey="'label'" :valueKey="'value'">
                        </common-select>
                    </div>
                </div>  
                <div class="field-row" v-show="meetingSystemType != 'A1' && recipientSocietyOrHospital === '1'" :class="required('recipientSocietyStr', meetingSystemType != 'A1' && recipientSocietyOrHospital === '1')">
                    <div class="field-input-no-title">受赠方名称<span>*</span></div><mt-field class="align-right" placeholder="请输入" v-model="addNewOrEditData.recipientSocietyStr"></mt-field>
                </div>   
                <div class="field-row" v-show="meetingSystemType != 'A1' && recipientSocietyOrHospital === '2'" :class="required('universityStr', meetingSystemType != 'A1' && recipientSocietyOrHospital === '2')">
                    <div class="field-input-no-title">受赠方名称<span>*</span></div><mt-field class="align-right" placeholder="请输入" v-model="addNewOrEditData.universityStr"></mt-field>
                </div>   
                <div class="field-row" v-show="meetingSystemType != 'A1' && recipientSocietyOrHospital === '3'" :class="required('patientOrgStr', meetingSystemType != 'A1' && recipientSocietyOrHospital === '3')">
                    <div class="field-input-no-title">受赠方名称<span>*</span></div><mt-field class="align-right" placeholder="请输入" v-model="addNewOrEditData.patientOrgStr"></mt-field>
                </div>   
                <div class="field-row" v-show="meetingSystemType != 'A1' && recipientSocietyOrHospital === '4'" :class="required('otherStr', meetingSystemType != 'A1' && recipientSocietyOrHospital === '4')">
                    <div class="field-input-no-title">受赠方名称<span>*</span></div><mt-field class="align-right" placeholder="请输入" v-model="addNewOrEditData.otherStr"></mt-field>
                </div>  
                <div v-show="(meetingSystemType == 'A1' || recipientSocietyOrHospital === '0') && !isOneHospital()">
                    <div class="field-title" :class="required('moreThenOneHospital', (meetingSystemType == 'A1' || recipientSocietyOrHospital === '0') && !isOneHospital())">医院总数<span>*</span></div>
                    <div class="field-row">
                        <mt-checklist
                            class="radio"
                            v-model="moreThenOneHospitalArray"
                            :options="moreThenOneHospitalOptions">
                        </mt-checklist>
                    </div>
                </div>    
            </div>
            <div class="field-block more-tab-block" v-show="(meetingSystemType == 'A1' || recipientSocietyOrHospital === '0')">     
                <div class="more-tab" :class="isOneHospital()?'full':''">
                    <div class="field-row" :class="required('hospitalLevelId', meetingSystemType == 'A1' || recipientSocietyOrHospital === '0')">
                        <common-select tipCode="9" :required="meetingSystemType == 'A1' || recipientSocietyOrHospital === '0'" clearable alignRight title="医院层级" placeholder="请选择" v-model="addNewOrEditData.hospitalLevelId"  :datas="filterHospitalLevel" :textKey="'hospitalLevel'" :valueKey="'id'">
                        </common-select>
                    </div>    
                    <div class="field-row" v-show="moreThenOneHospital == 1 && !isOneHospital()" :class="required('hospitalCount', (meetingSystemType == 'A1' || recipientSocietyOrHospital === '0') && moreThenOneHospital == 1 && !isOneHospital())">
                        <div class="field-input-no-title">医院数量<span>*</span></div><mt-field class="align-right" label="" placeholder="请输入医院数量" type="number" v-model="addNewOrEditData.hospitalCount" :attr="{ min: 0 }"></mt-field>
                    </div>          
                    <div class="field-row" v-show="!(moreThenOneHospital == 1 && !isOneHospital())" :class="required('hospitalId', (meetingSystemType == 'A1' || recipientSocietyOrHospital === '0') && !(moreThenOneHospital == 1 && !isOneHospital()))">
                        <common-select-search :required="(meetingSystemType == 'A1' || recipientSocietyOrHospital === '0') && !(moreThenOneHospital == 1 && !isOneHospital())" @change="addNewOrEditData.hospitalName = getName(addNewOrEditData.hospitalId, remoteHospitalData, 'id', 'hospitalName')" clearable alignRight title="医院" :placeholder="(isOneHospital() && !addNewOrEditData.cityName)?'请先选择城市':'请输入'" v-model="addNewOrEditData.hospitalId"  :datas="remoteHospitalData" :remote-method="handleHospitalFilter" :textKey="'hospitalName'" :valueKey="'id'">
                        </common-select-search>
                    </div>  
                    <div v-show="moreThenOneHospital == 1 && !isOneHospital()" class="operate-add-remove">
                        <i @click="AddNewHospitalInfo" class="iconfont icon-tianjia1"></i>
                    </div>    
                </div>    
                <div class="more-tab-div" v-show="moreThenOneHospital == 1 && !isOneHospital() && addNewOrEditData.extendData.hospitalInfos.length > 0">    
                    <div class="more-tab" v-for="(hospital,index) in addNewOrEditData.extendData.hospitalInfos" :key="index">
                        <div class="field-row" :class="required('extendData.hospitalInfos.'+index+'.hospitalLevelId', (meetingSystemType == 'A1' || recipientSocietyOrHospital === '0') && moreThenOneHospital == 1 && !isOneHospital())">
                            <common-select tipCode="9" :required="(meetingSystemType == 'A1' || recipientSocietyOrHospital === '0') && moreThenOneHospital == 1 && !isOneHospital()" clearable alignRight title="医院层级" placeholder="请选择" v-model="hospital.hospitalLevelId"  :datas="filterHospitalLevel" :textKey="'hospitalLevel'" :valueKey="'id'">
                            </common-select>
                        </div>    
                        <div class="field-row" :class="required('extendData.hospitalInfos.'+index+'.hospitalCount', (meetingSystemType == 'A1' || recipientSocietyOrHospital === '0') && moreThenOneHospital == 1 && !isOneHospital())">
                            <div class="field-input-no-title">医院数量<span>*</span></div><mt-field class="align-right" label="" placeholder="请输入医院数量" type="number" v-model="hospital.hospitalCount" :attr="{ min: 0 }"></mt-field>
                        </div> 
                        <div class="operate-add-remove">
                            <i @click="removeHosiptalInfo(index)" class="iconfont icon-shanjian"></i>
                        </div>   
                    </div>   
                </div>
            </div>             
            <div v-show="(meetingSystemType == 'A1' || recipientSocietyOrHospital === '0')" class="field-block field-block-no-top-margin">  
                <div class="field-title" :class="required('offices', (meetingSystemType == 'A1' || recipientSocietyOrHospital === '0') && meetingSystemType != 'GSD')">科室(多选)<span>*</span></div>
                <div class="field-row" :class="required('offices', (meetingSystemType == 'A1' || recipientSocietyOrHospital === '0') && meetingSystemType != 'GSD')">
                    <common-select-multiple filterable clearable title="" placeholder="请选择" v-model="addNewOrEditData.offices"  :datas="baseDataRecords.Office" :textKey="'officeName'" :valueKey="'id'">
                    </common-select-multiple>
                </div>  
            </div>   
            <div class="field-block field-block-no-top-margin">                  
                <div class="field-title" :class="required('includeSpeaker', true)">是否包含讲者<span>*</span></div>
                <div class="field-row">
                    <mt-checklist
                        class="radio"
                        v-model="includeSpeakerArray"
                        :options="includeSpeakerOptions">
                    </mt-checklist>
                </div>   
            </div>
            <div class="field-block more-tab-block" v-show="addNewOrEditData.includeSpeaker == 1">
                <div class="more-tab">
                    <div class="field-row" :class="required('speakerLevel', addNewOrEditData.includeSpeaker == 1 && meetingSystemType != 'GSD')">
                        <common-select tipCode="10" :required="meetingSystemType != 'GSD'" clearable alignRight title="讲者级别" placeholder="请选择" v-model="addNewOrEditData.speakerLevel"  :datas="filterSpeakerLevel" :textKey="'speakerLevel'" :valueKey="'id'">
                        </common-select>
                    </div>     
                    <div class="field-row" :class="required('speakerCount', addNewOrEditData.includeSpeaker == 1 && meetingSystemType != 'GSD')">
                        <div class="field-input-no-title">讲者人数<span>*</span></div><mt-field class="align-right" label="" placeholder="请输入人数" type="number" v-model="addNewOrEditData.speakerCount" :attr="{ min: 0 }"></mt-field>
                    </div> 
                    <div class="operate-add-remove">
                        <i @click="AddNewSpeakerInfo" class="iconfont icon-tianjia1"></i>
                    </div> 
                </div> 
                <div class="more-tab-div">
                    <div class="more-tab" v-for="(speaker,index) in addNewOrEditData.extendData.speakerInfos" :key="index">
                        <div class="field-row" :class="required('extendData.speakerInfos.'+index+'.speakerLevel', addNewOrEditData.includeSpeaker == 1 && meetingSystemType != 'GSD')">
                            <common-select tipCode="10" :required="meetingSystemType != 'GSD'" clearable alignRight title="讲者级别" placeholder="请选择" v-model="speaker.speakerLevel"  :datas="filterSpeakerLevel" :textKey="'speakerLevel'" :valueKey="'id'">
                            </common-select>
                        </div>    
                        <div class="field-row" :class="required('extendData.speakerInfos.'+index+'.speakerCount', addNewOrEditData.includeSpeaker == 1 && meetingSystemType != 'GSD')">
                            <div class="field-input-no-title">讲者人数<span>*</span></div><mt-field class="align-right" label="" placeholder="请输入人数" type="number" v-model="speaker.speakerCount" :attr="{ min: 0 }"></mt-field>
                        </div>  
                        <div class="operate-add-remove">
                            <i @click="removeSpeakerInfo(index)" class="iconfont icon-shanjian"></i>
                        </div> 
                    </div>   
                </div>
            </div>
            <div class="field-block"> 
                <div class="field-row" :class="required('attendCount', true)">
                    <div class="field-input-no-title">参会者人数 (外)<span>*</span></div><mt-field class="align-right" label="" placeholder="请输入人数" type="number" v-model="addNewOrEditData.attendCount" :attr="{ min: 0 }"></mt-field>
                </div> 
                <div class="field-row" :class="required('rocheCount', meetingSystemType != 'GSD')">
                    <div class="field-input-no-title">罗氏员工人数 (内)<span>*</span></div><mt-field class="align-right" label="" placeholder="请输入人数" type="number" v-model="addNewOrEditData.rocheCount" :attr="{ min: 0 }"></mt-field>
                </div> 
            </div>   
            <div class="field-block"> 
                <div class="field-row" :class="required('totalAmount', true)">
                    <div class="field-input-no-title">会议总预算 (CNY)<common-tooltip class="field-input-no-title-tooltip" tipCode="12"></common-tooltip><span>*</span></div><mt-field @blur.native.capture="handleAmountCheck" class="align-right" label="" placeholder="请输入金额" v-model="addNewOrEditData.totalAmount" :disabled="disableTotalAmount"></mt-field>
                </div> 
                <div class="field-row" :class="required('a1Amount', addNewOrEditData.meetingSystem.length == 2)" v-show="addNewOrEditData.meetingSystem.length == 2">
                    <div class="field-input-no-title">A1预算<span>*</span></div><mt-field @blur.native.capture="handleAmountCheck" class="align-right" label="" placeholder="请输入" v-model="addNewOrEditData.a1Amount"></mt-field>
                </div> 
                <div class="field-row" :class="required('gsdAmount', addNewOrEditData.meetingSystem.length == 2)" v-show="addNewOrEditData.meetingSystem.length == 2">
                    <div class="field-input-no-title">GSD预算<span>*</span></div><mt-field @blur.native.capture="handleAmountCheck" class="align-right" label="" placeholder="请输入" v-model="addNewOrEditData.gsdAmount"></mt-field>
                </div>     
                <div class="field-row" :class="required('costType', true)">
                    <common-select @change="handleCostTypeChange" required clearable alignRight title="类型" placeholder="请选择" v-model="addNewOrEditData.costType"  :datas="costTypeOptions" :textKey="'label'" :valueKey="'value'">
                    </common-select>
                </div>
                <!-- 成本中心（当costType=1时显示） -->
                <div class="field-row" v-if="addNewOrEditData.costType === '1'" :class="required('costCenter', addNewOrEditData.costType === '1')">
                    <common-select filterable @change="handleCostCenterChange" required clearable alignRight title="成本中心" placeholder="请选择" v-model="addNewOrEditData.costCenter"  :datas="costCenterData" :textKey="'costCenterAndcostCenterName'" :valueKey="'costCenter'" specialTextKey="specialText">
                    </common-select>
                </div>
                <!-- WBS code（当costType=1时显示，非必填） -->
                <div class="field-row" v-if="addNewOrEditData.costType === '1'">
                    <common-select clearable alignRight title="Statistical WBS code" placeholder="请选择" v-model="addNewOrEditData.wbsCode"  :datas="wbsCodeData" :textKey="'costId'" :valueKey="'costId'">
                    </common-select>
                </div>
                <!-- Real Wbs Code（当costType=2时显示，必填） -->
                <div class="field-row" v-if="addNewOrEditData.costType === '2'" :class="required('wbsCode', addNewOrEditData.costType === '2')">
                    <common-select clearable alignRight required title="Real Wbs Code" placeholder="请选择" v-model="addNewOrEditData.wbsCode"  :datas="wbsCodeData" :textKey="'costId'" :valueKey="'costId'">
                    </common-select>
                </div>
                <div class="field-row">
                    <common-select-search @change="addNewOrEditData.meetingOrganizerName = getName(addNewOrEditData.meetingOrganizerId, remoteMeetingOrganizerData, 'Id', 'AD');addNewOrEditData.meetingOrganizerCnname = getName(addNewOrEditData.meetingOrganizerId, remoteMeetingOrganizerData, 'Id', 'CName');" clearable alignRight title="会议申请人" placeholder="请选择申请人" v-model="addNewOrEditData.meetingOrganizerId"  :datas="remoteMeetingOrganizerData" :remote-method="handleMeetingOrganizerFilter" :textKey="'NameAndAd'" :valueKey="'Id'">
                    </common-select-search>
                </div>   
            </div> 
        </div>
        <div class="bottom-info">
            <mt-button type="primary" :loading="false" @click="handlerSave">保存</mt-button>
            <mt-button type="primary" plain :loading="false" v-if="editType != 'edit'" @click="goBack()">删除</mt-button>
            <mt-button type="primary" plain :loading="false" v-else @click="handleDeleteClick()">删除</mt-button>
        </div>
    </div>
</template>
<script> 
import costCenterAndWbs from '@/api/costCenterAndWbs';
import application from '@/api/meetingplan/application';
import privilege from '@/api/sysmanagement/privilege';
import basedata from '@/api/basedata';
import { mapGetters } from 'vuex';
import { Cell, Field,MessageBox, Toast, Checklist    } from 'mint-ui';
import utils from '@/util/utils';

export default {
    components: {
        Cell,
        MessageBox,
        Field,
        Checklist,
    },
  data() {
    return {
      addNewOrEditData: {
          costType: '1', // 新增：1-成本中心，2-Real Wbs Code
          meetingName: '',
          meetingType: '',
          isGsd: '',
          meetingGsdType: '',
          meetingGsdSubType: '',
          meetingProp: '',
          meetingModality: '',
          meetingSystem: [],
          departId: '',
          medicalField: '',
          teamL4: '',
          treatmentArea: '',
          diseaseArea: '',
          productId: [],
          companyStrategy: [],
          strategyKeynote: [],
          medicalFieldResult: [],
          medicalFieldResultDes: '',
          meetingBeginDate: '',
          meetingEndDate: '',
          meetingTimeInt: '',
          country: '',
          countryName: '',
          province: '',
          provinceName: '',
          city: '',
          cityName: '',
          meetingPlace: '',
          hospitalLevelId: '',
          hospitalCount: '',
          hospitalName: '',
          hospitalId: '',
          recipientSocietyStr: '',
          universityStr: '',
          patientOrgStr: '',
          otherStr: '',
          offices: [],
          speakerLevel: '',
          speakerCount: '',
          attendCount: '',
          rocheCount: '',
          totalAmount: '',
          costCenter: '',
          costCenterName: '',
          wbsCode: '',
          wbsCodeName: '',
          a1Amount: '',
          gsdAmount: '',
          meetingOrganizerId: '',
          meetingOrganizerName:'',
          includeSpeaker: '',
            extendData:{
                hospitalInfos: [],
                speakerInfos: [],
            },
            moreThenOneHospital: 0,
      },
      costTypeOptions: [
            {
                label: '成本中心',
                value: '1',
            },
            {
                label: 'Real Wbs Code',
                value: '2',
            },
        ],
      addNewOrEditDataValidation: {
      },
      startPickerOptions: {
        disabledDate: (time)=> {
            time = new Date(moment(time).format('YYYY-MM-DD'));
            if(this.seasonStartDate.getTime && time.getTime() < this.seasonStartDate.getTime()){
                return true;
            }

            if(this.seasonEndDate.getTime && time.getTime() > this.seasonEndDate.getTime()){
                return true;
            }

            if(!this.addNewOrEditData.meetingEndDate) {
              return false;
            }
            let endDate = new Date(moment(new Date(this.addNewOrEditData.meetingEndDate)).format('YYYY-MM-DD'));
            return time.getTime() > endDate.getTime();
          }
      },
      endPickerOptions: {
        disabledDate: (time)=> {
            time = new Date(moment(time).format('YYYY-MM-DD'));
            if(this.seasonStartDate.getTime && time.getTime() < this.seasonStartDate.getTime()){
                return true;
            }

            if(!this.addNewOrEditData.meetingBeginDate) {
              return false;
            }
            let startDate = new Date(moment(new Date(this.addNewOrEditData.meetingBeginDate)).format('YYYY-MM-DD'));
            return time.getTime() < startDate.getTime();
          }
      },
      remoteCitiesData: [],
      remoteProvinceData: [],
      remoteMeetingOrganizerData: [],
      remoteHospitalData: [],
      seasonStartDate: '',
      seasonEndDate: '',
      confirmDeleteVisible: false,
      editType: '',
      strategyData: [],
      domainResultData: [],
      hospitalLevelData: [],
      hospitalLevelDataObject: {},
      speakerLevelData: [],
      speakerLevelDataObject: {},
      costCenterData: [],
      wbsCodeData: [],
      recipientSocietyOrHospital: '1',
      moreThenOneHospitalArray: ['0'],
      moreThenOneHospital: 0,
      currentUserSelectVisibled: false,
      includeSpeakerArray: ['1'],
      isGsdOptions: [
        {
          label: '是',
          value: '1',
          disabled: false,
        },
        {
          label: '否',
          value: '0',
          disabled: false,
        },
      ],
      recipientSocietyOrHospitalOptions: [
        {
            label: '受赠学会',
            value: '1',
            disabled: false,
        },
        {
            label: '医院',
            value: '0',
            disabled: false,
        },
        {
            label: '大学',
            value: '2',
            disabled: false,
        },
        {
            label: '患者组织',
            value: '3',
            disabled: false,
        },
        {
            label: '其他',
            value: '4',
            disabled: false,
        },
      ],
      moreThenOneHospitalOptions: [
        {
            label: '一家',
            value: '0',
            disabled: true,
        },
        {
            label: '两家及以上',
            value: '1',
            disabled: false,
        },
      ],
      includeSpeakerOptions: [
        {
            label: '是',
            value: '1',
            disabled: true,
        },
        {
            label: '否',
            value: '0',
            disabled: false,
        },
      ],
      meetingPropAndTypeArrays: {
        selectMeetingProp:[], //可选的会议性质
        popMeetingType:[], //推广的会议类型绑定
        nopopMeetingType: [], //非推广的会议类型绑定
        meetingPropType: [] //推广+非推广的会议类型绑定
      },
      areaRelationObject: {
        '0': [],
        '1': [],
        '2': [],
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo','baseDataRecords','basedataGetName','basedataGetIdByName','basedataGetObject']),
    MeetingGsdSubTypes() {
        return this.baseDataRecords['MeetingGsdTypeSub'+this.addNewOrEditData.meetingGsdType] || [];
    },
    productArray() {
        if(!this.addNewOrEditData.meetingProp) {
            return []
        }

        let areaDbId = this.addNewOrEditData.diseaseArea;
        if(this.basedataGetName('MeetingProp',this.addNewOrEditData.meetingProp) == '推广') {
            areaDbId = this.addNewOrEditData.treatmentArea;            
        }
        if(!areaDbId) {
            return []
        }

        let areaObject = this.areaRelationObject[this.addNewOrEditData.meetingProp].filter(a => a.areaDbId == areaDbId)[0];

        if(areaObject) {
            return areaObject.productArray;
        }
        else {
            return []
        }
    },
    filterMeetingType() {
        if(!this.addNewOrEditData.meetingProp) {
            return []
        }
        switch(this.basedataGetName('MeetingProp',this.addNewOrEditData.meetingProp)) {
            case '推广':
                return this.meetingPropAndTypeArrays.popMeetingType;
            case '非推广':
                return this.meetingPropAndTypeArrays.nopopMeetingType;
            default:
                return this.meetingPropAndTypeArrays.meetingPropType;
        }
    },
    disableTotalAmount() {
      return false;
    //   return !!(this.addNewOrEditData.meetingType === '24' && this.isCEDepart());
    },
    disableSpeakerType() {
        let typeId = '';
        if(this.addNewOrEditData.speakerLevel) {
            if(this.speakerLevelDataObject[this.addNewOrEditData.speakerLevel] && this.speakerLevelDataObject[this.addNewOrEditData.speakerLevel]) {
                typeId = this.speakerLevelDataObject[this.addNewOrEditData.speakerLevel].typeId;
            }
        }
        else {
            for (let index = 0; index < this.addNewOrEditData.extendData.speakerInfos.length; index++) {
                const element = this.addNewOrEditData.extendData.speakerInfos[index];
                if(element.speakerLevel) {
                    if(this.speakerLevelDataObject[element.speakerLevel]) {
                        typeId = this.speakerLevelDataObject[element.speakerLevel].typeId;
                        break;
                    }
                }
            }
        }

        if(typeId === '0') {
            typeId = '1';
        }
        else if(typeId === '1') {
            typeId = '0';
        }

        return typeId;
    },
    disableHospitalType() {
        let typeId = '';
        if(this.addNewOrEditData.hospitalLevelId && this.hospitalLevelDataObject[this.addNewOrEditData.hospitalLevelId]) {
            typeId = this.hospitalLevelDataObject[this.addNewOrEditData.hospitalLevelId].typeId;
        }
        else {
            for (let index = 0; index < this.addNewOrEditData.extendData.hospitalInfos.length; index++) {
                const element = this.addNewOrEditData.extendData.hospitalInfos[index];
                if(element.hospitalLevelId && this.hospitalLevelDataObject[element.hospitalLevelId]) {
                    typeId = this.hospitalLevelDataObject[element.hospitalLevelId].typeId;
                    break;
                }
            }
        }

        if(typeId === '0') {
            typeId = '1';
        }
        else if(typeId === '1') {
            typeId = '0';
        }

        return typeId;
    },
    includeSpeakerBoolean: {
        get() {
            return this.addNewOrEditData.includeSpeaker?true:false;
        },
        set(val) {
            this.addNewOrEditData.includeSpeaker = val?1:0;
        }
    },
    meetingSystemType() {
        //GSD、A1、All、None
        if(this.addNewOrEditData.meetingSystem.length == 0) {
            return 'None';
        }
        if(this.addNewOrEditData.meetingSystem.length == 2) {
            return 'All';
        }
        if(this.addNewOrEditData.meetingSystem.length == 1) {
            return this.basedataGetName('MeetingSystem',this.addNewOrEditData.meetingSystem)
        }
    },
    filterStrategy() {        
        let temp = [];
        let productIds = this.addNewOrEditData.productId.join(',');
        this.strategyData.forEach(strategy => {
            if(this.addNewOrEditData.departId && this.addNewOrEditData.departId != strategy.departId){
                return;
            }
            if(this.addNewOrEditData.medicalField && this.addNewOrEditData.medicalField != strategy.medicalField){
                return;
            }
            if(this.addNewOrEditData.teamL4 && this.addNewOrEditData.teamL4 != strategy.teamL4){
                return;
            }
            if(productIds && productIds.indexOf(strategy.productId) < 0){
                return;
            }
            temp.push({
              ...strategy,
              productNameAndKeynote: `${strategy.productName} - ${strategy.keynote}`
            });
        })
        return temp;
    },
    filterSpeakerLevel() {
        let temp = [];
        this.speakerLevelData.forEach(speaker => {
            if(speaker.typeId == '1') {
                if(speaker.departId && this.addNewOrEditData.departId && this.addNewOrEditData.departId != speaker.departId){
                    return;
                }
                if(speaker.medicalField && this.addNewOrEditData.medicalField && this.addNewOrEditData.medicalField != speaker.medicalField){
                    return;
                }
                if(speaker.teamL4 && this.addNewOrEditData.teamL4 && this.addNewOrEditData.teamL4 != speaker.teamL4){
                    return;
                }
            }

            speaker.disabled = speaker.typeId === this.disableSpeakerType || this.isSelectedSpeakerLevel(speaker.id);

            temp.push(speaker);
        })

        return temp;
    },
    filterHospitalLevel() {        
        let temp = [];
        let productIds = this.addNewOrEditData.productId.join(',');
        this.hospitalLevelData.forEach(hospital => {
            if(hospital.typeId == '1') {
                if(hospital.departId && this.addNewOrEditData.departId && this.addNewOrEditData.departId != hospital.departId){
                    return;
                }
                if(hospital.medicalField && this.addNewOrEditData.medicalField && this.addNewOrEditData.medicalField != hospital.medicalField){
                    return;
                }
                if(hospital.teamL4 && this.addNewOrEditData.teamL4 && this.addNewOrEditData.teamL4 != hospital.teamL4){
                    return;
                }
                if(hospital.prodIds && productIds){
                    if(!hospital.prodIds) {
                        return;
                    }
                    let hospitalProdIds = hospital.prodIds.split(',');
                    let match = false;
                    for (let index = 0; index < hospitalProdIds.length; index++) {
                        const element = hospitalProdIds[index];      
                        if(productIds.indexOf(element) >= 0) {
                            match = true;
                            break;
                        }
                    }
                    if(!match){
                        return;
                    }
                }
            }

            hospital.disabled = hospital.typeId === this.disableHospitalType || this.isSelectedHospitalLevel(hospital.id);

            temp.push(hospital);
        })

        return temp;
    },
    filterDomainResult() {        
        let temp = [];
        let productIds = this.addNewOrEditData.productId.join(',');
        this.domainResultData.forEach(domainresult => {
            if(this.addNewOrEditData.departId && this.addNewOrEditData.departId != domainresult.departId){
                return;
            }
            if(this.addNewOrEditData.medicalField && this.addNewOrEditData.medicalField != domainresult.medicalField){
                return;
            }
            if(this.addNewOrEditData.teamL4 && this.addNewOrEditData.teamL4 != domainresult.teamL4){
                return;
            }
            if(productIds && productIds.indexOf(domainresult.productId) < 0){
                return;
            }
            temp.push({
              ...domainresult,
              productNameAndTreatAreaResult: `${domainresult.productName} - ${domainresult.treatAreaResult}`
            });
        })

        return temp;
    },
    isSeasonlyType() {
        if(this.addNewOrEditData.meetingDateType) {
            return this.addNewOrEditData.meetingDateType == '1';
        }

        if(this.addNewOrEditData.meetingBeginDate) {
            if(new Date().getFullYear() != new Date(this.addNewOrEditData.meetingBeginDate).getFullYear()
                || new Date().getMonth() != new Date(this.addNewOrEditData.meetingBeginDate).getMonth()) {
                return true;
            }
        }

        return false;
    },
  },
  methods: {
    handleMeetingPropChange() {
        this.addNewOrEditData.meetingType='';        
        this.addNewOrEditData.treatmentArea='';
        this.addNewOrEditData.diseaseArea='';
        this.addNewOrEditData.productId=[];
        this.resetRelativeFields();
    },
    handleAreaChange() {
        this.addNewOrEditData.productId=[];
        this.resetRelativeFields();
    },
    resetCostCenterList() {
        this.costCenterData = [];
        this.wbsCodeData = [];
        this.addNewOrEditData.costCenter = '';
        this.addNewOrEditData.wbsCode = '';
        if(!this.addNewOrEditData.departId || !this.addNewOrEditData.medicalField || !this.addNewOrEditData.teamL4){
            return;
        }

        costCenterAndWbs.listMeetingCostCenter(
            {
                departId:this.addNewOrEditData.departId,
                medicalField:this.addNewOrEditData.medicalField,
                teamL4: this.addNewOrEditData.teamL4
            }).then(res => {
                if(res) {
                    res.forEach(item => {
                        item.costCenterAndcostCenterName = item.costCenter + ' ' + item.costCenterName
                        if(item.isMe === '1') {
                            item.specialText = '本人';
                        }
                    })
                }
                this.costCenterData = res;
            })
    },
    // 新增：类型切换处理
    handleCostTypeChange() {
        // 先清除验证规则
        if (this.addNewOrEditDataValidation['costCenter']) {
            if (this.addNewOrEditDataValidation['costCenter'].unwatch) {
                this.addNewOrEditDataValidation['costCenter'].unwatch();
            }
            this.addNewOrEditDataValidation['costCenter'].required = false;
            this.addNewOrEditDataValidation['costCenter'].error = false;
        }
        
        if (this.addNewOrEditDataValidation['wbsCode']) {
            if (this.addNewOrEditDataValidation['wbsCode'].unwatch) {
                this.addNewOrEditDataValidation['wbsCode'].unwatch();
            }
            this.addNewOrEditDataValidation['wbsCode'].required = false;
            this.addNewOrEditDataValidation['wbsCode'].error = false;
        }
        
        if (this.addNewOrEditData.costType == '2') {
            // 切换到Real Wbs Code时，清空成本中心
            this.addNewOrEditData.costCenter = '';
            this.addNewOrEditData.costCenterName = '';
            this.addNewOrEditData.wbsCode = '';
            this.addNewOrEditData.wbsCodeName = '';

            if(!this.addNewOrEditData.departId || !this.addNewOrEditData.medicalField || !this.addNewOrEditData.teamL4){
                return;
            }
            costCenterAndWbs.listRealWbsCode(
                {
                    year:this.addNewOrEditData.year,
                    quarter:this.addNewOrEditData.season,
                    departId:this.addNewOrEditData.departId,
                    medicalField:this.addNewOrEditData.medicalField,
                    teamL4: this.addNewOrEditData.teamL4
                }
            )
            .then(res => {
                this.wbsCodeData = res;
            })
        } else {
            // 切换到成本中心时，清空WBS Code
            this.addNewOrEditData.wbsCode = '';
            this.addNewOrEditData.wbsCodeName = '';
            this.wbsCodeData = [];
            this.resetCostCenterList();
        }
        
        // 强制更新视图
        this.$forceUpdate();
    },
    handleCostCenterChange() {
        this.addNewOrEditData.wbsCode = ''
        this.wbsCodeData = [];

        if(!this.addNewOrEditData.costCenter) {
            return;
        }

        costCenterAndWbs.listLocalWbsCode(
            {
                companyCode: this.userInfo.companyCode,
                costCenter: this.addNewOrEditData.costCenter
            }
        )
        .then(res => {
            this.wbsCodeData = res;
        })
    },
    handleCostCenterSelectVisibleChange(visibled) {
        this.currentUserSelectVisibled = visibled;
    },
    isSelectedSpeakerLevel(speakerLevelId) {
        if(speakerLevelId == this.addNewOrEditData.speakerLevel) {
            return true;
        }

        if(this.addNewOrEditData.extendData.speakerInfos) {
            for (let index = 0; index < this.addNewOrEditData.extendData.speakerInfos.length; index++) {
                const element = this.addNewOrEditData.extendData.speakerInfos[index];
                
                if(element.speakerLevel == speakerLevelId) {
                    return true;
                }
            }
        }

        return false;
    },
    isSelectedHospitalLevel(hospitalLevelId) {
        if(hospitalLevelId == this.addNewOrEditData.hospitalLevelId) {
            return true;
        }

        if(this.addNewOrEditData.extendData.hospitalInfos) {
            for (let index = 0; index < this.addNewOrEditData.extendData.hospitalInfos.length; index++) {
                const element = this.addNewOrEditData.extendData.hospitalInfos[index];
                
                if(element.hospitalLevelId == hospitalLevelId) {
                    return true;
                }
            }
        }

        return false;
    },
    handleHospitalCountCheck() {
        if(this.meetingSystemType == 'A1' || this.recipientSocietyOrHospital === '0') {
           if(!this.isOneHospital() && this.moreThenOneHospital) {
                let hospitalTotalCount = this.addNewOrEditData.hospitalCount;

                this.addNewOrEditData.extendData.hospitalInfos.forEach(hs => {                        
                    hospitalTotalCount += hs.hospitalCount;
                })

                if(hospitalTotalCount < 2) {
                    Toast(this.basedataGetName('SysErrorTip',4));
                    return false;
                }
           }
        }

        return true;
    },   
    handleAmountCheck() {
        if(this.addNewOrEditData.meetingSystem.length == 2
        && this.addNewOrEditData.totalAmount > '' 
        && this.addNewOrEditData.a1Amount > '' 
        && this.addNewOrEditData.gsdAmount > '' 
        && parseFloat(this.addNewOrEditData.totalAmount) != parseFloat(this.addNewOrEditData.a1Amount) + parseFloat(this.addNewOrEditData.gsdAmount)) {
            Toast(this.basedataGetName('SysErrorTip',2));
            return false;
        }

        return true;
    }, 
    isOneHospital(hospitalObj) {
        return this.basedataGetName('MeetingType',this.addNewOrEditData.meetingType) == '科室会' || 
                this.basedataGetName('MeetingType',this.addNewOrEditData.meetingType) == '院内会';
    },
    isCEDepart() {
      return this.addNewOrEditData.departId === 'CE-OMNI' || this.addNewOrEditData.departId === 'CE-ONCO';
    },
    required(field, isRequired, thisField = false) {
        if(!this.addNewOrEditDataValidation[field]) {
            this.addNewOrEditDataValidation[field] = {
                required: false,
                error: false,
                thisField: thisField,
                touched: false
            }
        }

        // 如果必填状态发生变化，更新验证规则
        if (this.addNewOrEditDataValidation[field].required !== isRequired) {
            this.addNewOrEditDataValidation[field].required = isRequired;
            
            // 如果之前有watch，先取消
            if(this.addNewOrEditDataValidation[field].unwatch) {
                this.addNewOrEditDataValidation[field].unwatch();
                this.addNewOrEditDataValidation[field].unwatch = null;
            }
        }

        // 只在字段已经被触碰过（即点击过保存）时才进行实时验证
        if(isRequired && this.addNewOrEditDataValidation[field].touched && !this.addNewOrEditDataValidation[field].unwatch) {
            let watchField = (thisField?'':'addNewOrEditData.')+field;
            this.addNewOrEditDataValidation[field].unwatch = this.$watch(watchField, function (newVal, oldVal) {
                this.$nextTick(() => {
                    if(this.addNewOrEditDataValidation[field].required && this.addNewOrEditDataValidation[field].touched) {
                        if(Array.isArray(newVal)) {
                            this.addNewOrEditDataValidation[field].error = newVal.length == 0;
                        }
                        else{
                            this.addNewOrEditDataValidation[field].error = !(newVal || newVal === 0);
                        }
                        
                        this.$forceUpdate();
                    }   
                })   
            }, { immediate: true })
        }
        
        if(!isRequired){
            if(this.addNewOrEditDataValidation[field].unwatch) {
                this.addNewOrEditDataValidation[field].unwatch();
                this.addNewOrEditDataValidation[field].unwatch = null;
            }
            this.addNewOrEditDataValidation[field].error = false;
        }

        let cls = [
            // 星号：只要字段是必填就显示，不依赖 touched
            isRequired ? 'field-row-required' : '',
            // 红色边框：只有 touched 为 true 且验证失败时才显示
            (this.addNewOrEditDataValidation[field].error && this.addNewOrEditDataValidation[field].touched) ? 'field-row-error' : '',
        ]
        return cls;
    },
    AddNewHospitalInfo() {
        this.addNewOrEditData.extendData.hospitalInfos.push({});
    },
    removeHosiptalInfo(index) {
        this.addNewOrEditData.extendData.hospitalInfos = this.addNewOrEditData.extendData.hospitalInfos.slice(0, index).concat( this.addNewOrEditData.extendData.hospitalInfos.slice(index + 1,  this.addNewOrEditData.extendData.hospitalInfos.length));
    },
    AddNewSpeakerInfo() {
        this.addNewOrEditData.extendData.speakerInfos.push({});
    },
    removeSpeakerInfo(index) {
        this.addNewOrEditData.extendData.speakerInfos = this.addNewOrEditData.extendData.speakerInfos.slice(0, index).concat( this.addNewOrEditData.extendData.speakerInfos.slice(index + 1,  this.addNewOrEditData.extendData.speakerInfos.length));
    },
    handleMeetingOrganizerFilter(query) {
        if(!query) {
            this.remoteMeetingOrganizerData = [];
            return;
        }
        
        application.filterMeetingOrganizer({'name':query})
          .then(res => {
            if(res) {
                res.forEach(item => {
                    item.NameAndAd = item.CName+' '+item.AD;
                })
            }
            this.remoteMeetingOrganizerData = res;
          })
    },
    handleHospitalFilter(query) {
        if(!query || (this.isOneHospital() && !this.addNewOrEditData.cityName)) {
            this.remoteHospitalData = [];
            this.remoteHospitalDataTemp = [];
            return;
        }
        
        let cityName = this.isOneHospital()?this.addNewOrEditData.cityName:'';

      application.filterHospital({'hospitalName' : query})
          .then(res => {
            this.remoteHospitalData = res.records;
          })
    },
    handleCountryChange() {
      this.addNewOrEditData.countryName = this.basedataGetName('Country', this.addNewOrEditData.country)
      this.addNewOrEditData.province = '';
      this.addNewOrEditData.provinceName = '';
      this.addNewOrEditData.city = '';
      this.addNewOrEditData.cityName = '';
      this.clearHospital();
      if(this.addNewOrEditData.country) {
        basedata.listProvince({countryId:this.addNewOrEditData.country})
                .then(res => {
                  this.remoteProvinceData = res.records;
                })
      }
      else {
        this.remoteProvinceData = []
        this.remoteCitiesData = []
      }
    },
    handleMeetingTypeChange() {
      this.addNewOrEditData.isGsd = '';
      this.checkTotalAmount();
    },
    handleDepartChange() {
      this.checkTotalAmount();
      this.resetRelativeFields();
    },
    checkTotalAmount() {
      if (this.disableTotalAmount) {
        this.addNewOrEditData.totalAmount = 1;
      }
    },
    handleProvinceChange() {
      this.addNewOrEditData.provinceName = this.getName(this.addNewOrEditData.province, this.remoteProvinceData, 'id', 'name')
      this.addNewOrEditData.city = '';
      this.addNewOrEditData.cityName = '';
      this.clearHospital();
      if(this.addNewOrEditData.province) {
        basedata.listCity({provinceId:this.addNewOrEditData.province})
                .then(res => {
                  this.remoteCitiesData = res.records;
                })
      }
      else {
        this.remoteCitiesData = []
      }
    },    
    clearHospital() {
        this.addNewOrEditData.hospitalId = '';
        this.addNewOrEditData.hospitalName = '';
    },
    confirmTemplate(message, subMessage) {
        var tempate = '';
        if(subMessage) {
            tempate = '<div class="message-alert">'+
                    '<div>'+
                        '<i class="iconfont icon-jingshi"></i>'+
                    '</div>'+
                    '<div class="common-confirm-info-no-bottom">'+
                        message+
                    '</div>'+
                    '<div class="common-confirm-info">'+
                        subMessage+
                    '</div>'+
                '</div>';
        }
        else {
            tempate = '<div class="message-alert">'+
                    '<div>'+
                        '<i class="iconfont icon-jingshi"></i>'+
                    '</div>'+
                    '<div class="common-confirm-info">'+
                        message+
                    '</div>'+
                '</div>';
        }
        return tempate;
    },
    getValue(obj,key) {
        let keysArray = key.split('.');
        let val = obj;
        keysArray.forEach(key => {
            val = val[key];
        })
        return val;
    },
    validForm() {
        let result = true;
        for (const key in this.addNewOrEditDataValidation) {
            if (Object.hasOwnProperty.call(this.addNewOrEditDataValidation, key)) {
                const element = this.addNewOrEditDataValidation[key];

                // 根据当前costType动态判断是否需要验证
                if (key === 'costCenter' && this.addNewOrEditData.costType !== '1') {
                    continue;
                }
                if (key === 'wbsCode' && this.addNewOrEditData.costType !== '2') {
                    continue;
                }

                if(element.required) {
                    // 标记字段已经被触碰过
                    element.touched = true;
                    
                    let val = null;
                    if(element.thisField) {
                        val = this.getValue(this.$data,key)
                    }
                    else {
                        val = this.getValue(this.addNewOrEditData,key)
                    }
                    if(Array.isArray(val)) {
                        element.error = val.length == 0;
                    }
                    else{
                        element.error = !(val || val === 0);
                    }

                    if(element.error) {
                        result = false;
                    }
                }                   
            }
        }      
        
        if(!result) {
            this.$forceUpdate();
        }  

        return result;
    },
    handlerSave() {
        if(!this.handleHospitalCountCheck()) {
            return;
        }

        if(!this.handleAmountCheck()) {
            return;
        }

        if(!this.validForm()) {
            Toast(this.basedataGetName('SysErrorTip',1));
            return;
        }
        if(this.isSeasonlyType){
            MessageBox({
                message: this.confirmTemplate('确认保存会议？', '该季度的计划申请，需要直线经理和二级审批人审批'),
                title: '',
                cancelButtonText: '返回',
                confirmButtonText: '确认',
                showCancelButton: true,
            }).then((action) => {
                if(action != 'cancel') {
                    this.handlerSaveConfirmOK()
                }
            });
        }
        else {
            let saveData = this.getSaveData();
            application.saveMeetingApprove(saveData)
                    .then(res => {
                        MessageBox({
                            message: this.confirmTemplate('确认保存会议？', res),
                            title: '',
                            cancelButtonText: '返回',
                            confirmButtonText: '确认',
                            showCancelButton: true,
                        }).then((action) => {
                            if(action != 'cancel') {
                                this.handlerSaveConfirmOK()
                            }
                        });
                    })
        }
    },
    getSaveData() {
        if (!(this.addNewOrEditData.meetingType == '24' && this.isCEDepart())) {
          this.addNewOrEditData.isGsd = '';
        }
        //治疗领域、疾病领域根据系统情况确定是否清空
        if(this.basedataGetName('MeetingProp',this.addNewOrEditData.meetingProp) != '推广') {
            this.addNewOrEditData.treatmentArea = ''
        }

        if(this.basedataGetName('MeetingProp',this.addNewOrEditData.meetingProp).indexOf('非推广') < 0) {
            this.addNewOrEditData.diseaseArea = ''
        }

        if(this.meetingSystemType == 'GSD') {
            this.addNewOrEditData.meetingType = '';
        }

        if(this.meetingSystemType == 'A1') {
            this.addNewOrEditData.meetingGsdType = '';
            this.addNewOrEditData.meetingGsdSubType = '';
        }

        //治疗领域业务结果（自定义描述）根据治疗领域业务结果是否清空
        if(this.addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') < 0) {
            this.addNewOrEditData.medicalFieldResultDes = '';
        }

        //医院名称及受赠学会根据系统情况确定是否清空
        if(this.meetingSystemType == 'A1' || this.recipientSocietyOrHospital === '0') {
            //医院输入
            this.addNewOrEditData.recipientSocietyStr = '';
            this.addNewOrEditData.universityStr = '';
            this.addNewOrEditData.patientOrgStr = '';
            this.addNewOrEditData.otherStr = '';

            if(this.isOneHospital() || !this.moreThenOneHospital) {
                //一家医院                
                this.addNewOrEditData.hospitalCount = 1;
                this.addNewOrEditData.extendData.hospitalInfos = [];
            }
            else {
                //多家医院
                this.addNewOrEditData.hospitalId = '';
                this.addNewOrEditData.hospitalName = '';

                this.addNewOrEditData.extendData.hospitalInfos.forEach(hs => {                        
                    hs.hospitalId = '';
                    hs.hospitalName = '';
                })
            }
        }
        else{
            //受赠输入
            this.addNewOrEditData.hospitalLevelId = '';
            this.addNewOrEditData.hospitalCount = '';
            this.addNewOrEditData.hospitalId = '';
            this.addNewOrEditData.hospitalName = '';
            this.addNewOrEditData.extendData.hospitalInfos = [];
            this.addNewOrEditData.offices = [];

            if(this.recipientSocietyOrHospital !== '1') {
                this.addNewOrEditData.recipientSocietyStr = '';
            }
            if(this.recipientSocietyOrHospital !== '2') {
                this.addNewOrEditData.universityStr = '';
            }
            if(this.recipientSocietyOrHospital !== '3') {
                this.addNewOrEditData.patientOrgStr = '';
            }
            if(this.recipientSocietyOrHospital !== '4') {
                this.addNewOrEditData.otherStr = '';
            }
        }

        //A1预算、GSD预算根据系统情况确定是否清空
        if(this.addNewOrEditData.meetingSystem.length != 2)
        {
            this.addNewOrEditData.a1Amount = 0;
            this.addNewOrEditData.gsdAmount = 0;
        }

        //是否包含讲者根据系统情况确定是否清空
        //下面代码增加讲者信息时已经处理

        let temp = _.clone(this.addNewOrEditData);


        //转换日期格式
        temp.meetingBeginDate = moment(temp.meetingBeginDate).format('YYYY-MM-DD HH:mm:ss');
        temp.meetingEndDate = moment(temp.meetingEndDate).format('YYYY-MM-DD HH:mm:ss');
        
        //转换多选项
        temp.companyStrategy = temp.companyStrategy.join(',');
        temp.medicalFieldResult = temp.medicalFieldResult.join(',');
        temp.meetingSystem = temp.meetingSystem.join(',');
        temp.offices = temp.offices.join(',');
        temp.productId = temp.productId.join(',');
        temp.strategyKeynote = temp.strategyKeynote.join(',');

        //转换医院信息
        temp.pubMeetingHospitalLevelList = [];
        if(this.addNewOrEditData.hospitalLevelId) {
            temp.pubMeetingHospitalLevelList.push(
                {
                    hospitalLevelId: this.addNewOrEditData.hospitalLevelId,
                    count: this.addNewOrEditData.hospitalCount,
                    hospitalId: this.addNewOrEditData.hospitalId,
                    hospitalName: this.addNewOrEditData.hospitalName,
                }
            )
        }
        temp.hospitalLevelId = '';
        temp.hospitalCount = '';
        temp.hospitalId = '';
        temp.hospitalName = '';

        this.addNewOrEditData.extendData.hospitalInfos.forEach(hospital => {
            temp.pubMeetingHospitalLevelList.push(
                {
                    hospitalLevelId: hospital.hospitalLevelId,
                    count: hospital.hospitalCount,
                    hospitalId: hospital.hospitalId,
                    hospitalName: hospital.hospitalName,
                }
            )
        })

        //转换讲者信息
        temp.pubMeetingSpeakerLevelList = [];
        if(this.addNewOrEditData.includeSpeaker) {
            temp.pubMeetingSpeakerLevelList.push(
                {
                    speakerLevel: this.addNewOrEditData.speakerLevel,
                    count: this.addNewOrEditData.speakerCount,
                }
            )
        }
        temp.speakerLevel = '';
        temp.speakerCount = '';

        if(this.addNewOrEditData.includeSpeaker) {
            this.addNewOrEditData.extendData.speakerInfos.forEach(speaker => {
                temp.pubMeetingSpeakerLevelList.push(
                    {
                        speakerLevel: speaker.speakerLevel,
                        count: speaker.speakerCount,
                    }
                )
            })
        }

        temp.extendData = '';

        return temp;
    },
    handlerSaveConfirmOK() {
        let temp = this.getSaveData();  

        let funName = (this.editType == 'add' || this.editType == 'copy')?'add': 'edit';

        if(this.editType == 'add' || this.editType == 'copy') {
            delete temp.id;
        }

        application[funName](temp)
                    .then(res => {
                        this.$router.push({
                            name:'meetingplan-application'
                        })
                    });
    },
    handleDeleteClick() {
        MessageBox({
            message: this.confirmTemplate('确认删除会议？', ''),
            title: '',
            cancelButtonText: '返回',
            confirmButtonText: '确认',
            showCancelButton: true,
        }).then((action) => {
            if(action != 'cancel'){
                this.handlerDeleteConfirmOK()
            }
        });
    },
    handlerDeleteConfirmOK() {
        application.delete({id:this.$route.params.id})
                    .then(res => {
                        history.back();
                    });
    },
    goBack() {
        history.back();
    },
    getName(value, array, idField, nameField) {
        for (let index = 0; index < array.length; index++) {
            const element = array[index];
            if(element[idField] == value) {
                return element[nameField];
            }
        }

        return '';
    },    
    initCreateMeetingInfo() {
      application.getCanCreateMeeting({
        year: this.$route.params.year || this.addNewOrEditData.year,
        season: this.$route.params.season || this.addNewOrEditData.season,
      }).then(res => {
        let today = moment().format('YYYY-MM-DD');
        this.seasonStartDate = res.meetingBeginDateStart >= today?res.meetingBeginDateStart:today;
        this.seasonStartDate = new Date(this.seasonStartDate);
        this.seasonEndDate = res.meetingBeginDateEnd;
        this.seasonEndDate = new Date(this.seasonEndDate);
      });
    },
    setRelativeFieldsFilterData() {
        this.$refs.domainResult.setDatas(this.filterDomainResult);
        this.$refs.strategy.setDatas(this.filterStrategy);
        // this.$refs.hospitalLevel.setDatas(this.filterHospitalLevel);
    },
    resetRelativeFields() {   
        this.setRelativeFieldsFilterData();

        this.addNewOrEditData.strategyKeynote = [];

        this.addNewOrEditData.speakerLevel = '';
        this.addNewOrEditData.extendData.speakerInfos.forEach(innerSpeaker => {
            innerSpeaker.speakerLevel = '';
        })

        this.addNewOrEditData.hospitalLevelId = '';
        this.addNewOrEditData.extendData.hospitalInfos.forEach(innerSpeaker => {
            innerSpeaker.hospitalLevelId = '';
        })

        this.addNewOrEditData.medicalFieldResult = [];

        this.resetCostCenterList();
    },
    filterListArray(array,valueFieldName,valueArray) {
        let _this = this;
        let resArr = valueArray.filter(function (value) {
                                    return _this.hasValue(array,valueFieldName,value);
                                });
        return resArr;
    },
    hasValue(array,valueFieldName,value) {
        for (let index = 0; index < array.length; index++) {
            const element = array[index];
            if(element[valueFieldName] == value) {
                return true;
            }
        }
        
        return false;
    },   
    init() {
        if(this.editType == 'add'){
            this.addNewOrEditData.year = this.$route.params.year;
            this.addNewOrEditData.season = this.$route.params.season;

            if(this.baseDataRecords.Depart.length > 0) {
                this.addNewOrEditData.departId = this.baseDataRecords.Depart[0].id;
            }
            if(this.baseDataRecords.MedicalField.length > 0) {
                this.addNewOrEditData.medicalField = this.baseDataRecords.MedicalField[0].id;
            }
            if(this.baseDataRecords.Teams.length > 0) {
                this.addNewOrEditData.teamL4 = this.baseDataRecords.Teams[0].id;
            }

            this.addNewOrEditData.country = this.basedataGetIdByName('Country','中国');
            this.handleCountryChange();

            this.addNewOrEditData.includeSpeaker = 1; 

            this.initCreateMeetingInfo();
            this.resetCostCenterList();

            this.setRelativeFieldsFilterData();
        }
        else {
            application.queryById({id:this.$route.params.id})
                .then(res => {
                    //转换多选项
                    res.companyStrategy = res.companyStrategy?res.companyStrategy.split(','):[];
                    res.medicalFieldResult = res.medicalFieldResult?res.medicalFieldResult.split(','):[];
                    res.meetingSystem = res.meetingSystem?res.meetingSystem.split(','):[];
                    res.offices = res.offices?res.offices.split(','):[];
                    res.productId = res.productId?res.productId.split(','):[];
                    res.strategyKeynote = res.strategyKeynote?res.strategyKeynote.split(','):[];

                    //新需求字段初始化
                    res.meetingGsdType = res.meetingGsdType || '';
                    res.meetingGsdSubType = res.meetingGsdSubType || '';
                    res.universityStr = res.universityStr || '';
                    res.patientOrgStr = res.patientOrgStr || '';
                    res.otherStr = res.otherStr || '';
                    res.teamL4 = res.teamL4 || '';
                    
                    res.extendData = {
                        hospitalInfos:[],
                        speakerInfos:[],
                    };
                    res.costType = res.costType ? res.costType : '1';

                    //设置省份、城市
                    basedata.listProvince({countryId:res.country})
                            .then(countryRes => {
                                this.remoteProvinceData = countryRes.records;
                            })
                    basedata.listCity({provinceId:res.province})
                            .then(provinceRes => {
                                this.remoteCitiesData = provinceRes.records;
                            })

                    // ========== 修改开始：根据 costType 加载不同的数据 ==========
                    if (res.costType === '1') {
                        // 成本中心模式：加载成本中心列表
                        costCenterAndWbs.listMeetingCostCenter({
                            departId: res.departId,
                            medicalField: res.medicalField,
                            teamL4: res.teamL4
                        }).then(costCenterRes => {
                            if(costCenterRes) {
                                costCenterRes.forEach(item => {
                                    item.costCenterAndcostCenterName = item.costCenter + ' ' + item.costCenterName
                                    if(item.isMe === '1') {
                                        item.specialText = '本人';
                                    }
                                })
                            }
                            this.costCenterData = costCenterRes;
                            
                            // 加载成本中心对应的 WBS Code
                            if(res.costCenter) {
                                costCenterAndWbs.listLocalWbsCode({
                                    companyCode: this.userInfo.companyCode,
                                    costCenter: res.costCenter
                                }).then(wbsRes => {
                                    this.wbsCodeData = wbsRes;
                                })
                            }
                        })
                    } else if (res.costType === '2') {
                        // Real Wbs Code 模式：加载 Real Wbs Code 列表
                        if(res.departId && res.medicalField && res.teamL4) {
                            costCenterAndWbs.listRealWbsCode({
                                year: res.year,
                                quarter: res.season,
                                departId: res.departId,
                                medicalField: res.medicalField,
                                teamL4: res.teamL4
                            }).then(wbsRes => {
                                this.wbsCodeData = wbsRes || [];
                            }).catch(err => {
                                console.error('加载Real Wbs Code失败:', err);
                                this.wbsCodeData = [];
                            })
                        }
                    }
                    // ========== 修改结束 ==========

                    //模糊查询设置
                    if(res.meetingOrganizerId) {
                        this.remoteMeetingOrganizerData = [];
                        this.remoteMeetingOrganizerData.push({
                            AD:res.meetingOrganizerName,
                            Id:res.meetingOrganizerId,
                            CName:res.meetingOrganizerCnname,
                            NameAndAd : res.meetingOrganizerCnname+' '+res.meetingOrganizerName
                        })
                    }
                    if(res.pubMeetingHospitalLevelList.length > 0) {
                        this.remoteHospitalData = [];
                    }

                    //转换医院信息
                    let tempRemoteHospitalDataObj = {}
                    if(res.pubMeetingHospitalLevelList.length > 0) {
                        if(res.pubMeetingHospitalLevelList[0].hospitalId) {
                            this.remoteHospitalData.push({
                                hospitalName:res.pubMeetingHospitalLevelList[0].hospitalName,
                                id: res.pubMeetingHospitalLevelList[0].hospitalId
                            })
                        }
                        tempRemoteHospitalDataObj[res.pubMeetingHospitalLevelList[0].hospitalId] = 1;
                        res.hospitalLevelId = res.pubMeetingHospitalLevelList[0].hospitalLevelId;
                        res.hospitalCount = res.pubMeetingHospitalLevelList[0].count;
                        res.hospitalId = res.pubMeetingHospitalLevelList[0].hospitalId;
                        res.hospitalName = res.pubMeetingHospitalLevelList[0].hospitalName;
                    }
                    if(res.pubMeetingHospitalLevelList.length > 1) {
                        for (let index = 1; index < res.pubMeetingHospitalLevelList.length; index++) {
                            const element = res.pubMeetingHospitalLevelList[index];

                            res.extendData.hospitalInfos.push({
                                hospitalLevelId : element.hospitalLevelId,
                                hospitalCount : element.count,
                                hospitalId: element.hospitalId,
                                hospitalName : element.hospitalName,
                            })
                        }
                    }
                    res.pubMeetingHospitalLevelList = '';

                    //转换讲者信息
                    res.includeSpeaker = res.pubMeetingSpeakerLevelList.length > 0? 1 :0;
                    this.includeSpeakerArray = [res.includeSpeaker.toString()]
                    this.includeSpeakerOptions[0].disabled = res.includeSpeaker == 1;
                    this.includeSpeakerOptions[1].disabled = res.includeSpeaker == 0;
                    if(res.pubMeetingSpeakerLevelList.length > 0) {
                        res.speakerLevel = res.pubMeetingSpeakerLevelList[0].speakerLevel;
                        res.speakerCount = res.pubMeetingSpeakerLevelList[0].count;
                    }
                    if(res.pubMeetingSpeakerLevelList.length > 1) {
                        for (let index = 1; index < res.pubMeetingSpeakerLevelList.length; index++) {
                            const element = res.pubMeetingSpeakerLevelList[index];

                            res.extendData.speakerInfos.push({
                                speakerLevel : element.speakerLevel,
                                speakerCount : element.count,
                            })
                        }
                    }
                    res.pubMeetingSpeakerLevelList = '';

                    if(this.editType == 'copy'){     
                        let today = new Date(new Date().toDateString());

                        if(res.meetingBeginDate && Date.parse(res.meetingBeginDate) < today) {
                            res.meetingBeginDate = ''
                        }

                        if(res.meetingEndDate && Date.parse(res.meetingEndDate) < today) {
                            res.meetingEndDate = ''
                        }
                    } 

                    if(res.meetingBeginDate) {
                        res.meetingBeginDate = moment(res.meetingBeginDate).format('YYYY-MM-DD');
                    }
                    if(res.meetingEndDate) {
                        res.meetingEndDate = moment(res.meetingEndDate).format('YYYY-MM-DD');
                    }

                    this.addNewOrEditData = res;

                    this.addNewOrEditData.strategyKeynote = this.filterListArray(this.filterStrategy,'id',this.addNewOrEditData.strategyKeynote);
                    this.addNewOrEditData.medicalFieldResult = this.filterListArray(this.filterDomainResult,'id',this.addNewOrEditData.medicalFieldResult)
                    this.addNewOrEditData.hospitalLevelId = this.hasValue(this.filterHospitalLevel,'id',this.addNewOrEditData.hospitalLevelId)?this.addNewOrEditData.hospitalLevelId:'';
                    this.addNewOrEditData.extendData.hospitalInfos.forEach(hos => {
                        hos.hospitalLevelId = this.hasValue(this.filterHospitalLevel,'id',hos.hospitalLevelId)?hos.hospitalLevelId:'';
                    })
                    if(this.addNewOrEditData.includeSpeaker) {
                        this.addNewOrEditData.speakerLevel = this.hasValue(this.filterSpeakerLevel,'id',this.addNewOrEditData.speakerLevel)?this.addNewOrEditData.speakerLevel:'';
                        this.addNewOrEditData.extendData.speakerInfos.forEach(spk => {
                            spk.speakerLevel = this.hasValue(this.filterSpeakerLevel,'id',spk.speakerLevel)?spk.speakerLevel:'';
                        })
                    }
                    if(this.addNewOrEditData.extendData.hospitalInfos.length > 0) {
                        this.setRecipientSocietyOrHospital('0');
                        this.setMoreThenOneHospitall(1);
                    }
                    else {
                        if(this.addNewOrEditData.hospitalId || this.addNewOrEditData.hospitalCount > 0) {
                            if(this.addNewOrEditData.hospitalCount > 1) {
                                this.setRecipientSocietyOrHospital('0');
                                this.setMoreThenOneHospitall(1);
                            }
                            else {
                                this.setRecipientSocietyOrHospital('0');
                                this.setMoreThenOneHospitall(0);                                 
                            }
                        }
                        else {
                            if(this.addNewOrEditData.recipientSocietyStr) {
                                this.setRecipientSocietyOrHospital('1');
                            }
                            if(this.addNewOrEditData.universityStr) {
                                this.setRecipientSocietyOrHospital('2');
                            }
                            if(this.addNewOrEditData.patientOrgStr) {
                                this.setRecipientSocietyOrHospital('3');
                            }
                            if(this.addNewOrEditData.otherStr) {
                                this.setRecipientSocietyOrHospital('4');
                            }
                            this.setMoreThenOneHospitall(0);
                        }
                    }
                    
                    this.initCreateMeetingInfo();

                    this.setRelativeFieldsFilterData();

                    //单独初始化状态控制
                    this.$refs.meetingSystem.setDatas(this.baseDataRecords.MeetingSystem);
                })
        }     
    },
    setRecipientSocietyOrHospital(val) {
        this.recipientSocietyOrHospital = val;
    },
    setMoreThenOneHospitall(val) {
        this.moreThenOneHospital = val;
        this.addNewOrEditData.moreThenOneHospital = val;
        this.moreThenOneHospitalArray = [val.toString()];
        this.moreThenOneHospitalOptions[0].disabled = val == 0;
        this.moreThenOneHospitalOptions[1].disabled = val == 1;
    }
  },  
  watch: {
    'addNewOrEditData.extendData.hospitalInfos' : function() {
        for (const key in this.addNewOrEditDataValidation) {
            if (Object.hasOwnProperty.call(this.addNewOrEditDataValidation, key)) {
                if(key.indexOf('extendData.hospitalInfos') == 0) {
                    if(this.addNewOrEditDataValidation[key].unwatch) {
                        this.addNewOrEditDataValidation[key].unwatch()
                    }
                    delete this.addNewOrEditDataValidation[key];
                }
            }
        }
    },    
    'addNewOrEditData.extendData.speakerInfos' : function() {
        for (const key in this.addNewOrEditDataValidation) {
            if (Object.hasOwnProperty.call(this.addNewOrEditDataValidation, key)) {
                if(key.indexOf('extendData.speakerInfos') == 0) {
                    if(this.addNewOrEditDataValidation[key].unwatch) {
                        this.addNewOrEditDataValidation[key].unwatch()
                    }
                    delete this.addNewOrEditDataValidation[key];
                }
            }
        }
    },
    'moreThenOneHospitalArray' : function(newValue, oldValue) {
        if(newValue.length != 2 || oldValue.length != 1){
            return;
        }
        if(this.moreThenOneHospital == 0) {
           this.setMoreThenOneHospitall(1);
        }
        else {
            this.setMoreThenOneHospitall(0);        
        }
    },
    'includeSpeakerArray' : function(newValue, oldValue) {
        if(newValue.length != 2 || oldValue.length != 1){
            return;
        }
        if(this.includeSpeakerBoolean) {
            this.includeSpeakerArray = ['0'];
            this.includeSpeakerBoolean = false;
            this.includeSpeakerOptions[0].disabled = false;
            this.includeSpeakerOptions[1].disabled = true;
        }
        else {
            this.includeSpeakerArray = ['1'];
            this.includeSpeakerBoolean = true;
            this.includeSpeakerOptions[0].disabled = true;
            this.includeSpeakerOptions[1].disabled = false;            
        }
    },
  },
  mounted() {       
        this.editType = this.$route.name.replace('meetingplan-application-','')
   
        utils.$all([
            basedata.listStrategy(),
            basedata.listDomainResult(),
            basedata.listHospitalLevel(),
            basedata.listSpeakerLevel(),
            application.queryMeetingPropAndTypeSelect(),
            application.queryAreaRelationList({pageNo:1,pageSize:999999})
        ]).then(resList => {
            this.strategyData = resList[0].records;
            this.domainResultData = resList[1].records;
            this.hospitalLevelData = resList[2].records; 
            this.hospitalLevelData.forEach(hp => {
                this.hospitalLevelDataObject[hp.id] = hp;
            })          
            this.speakerLevelData = resList[3].records;  
            this.speakerLevelData.forEach(sp => {
                this.speakerLevelDataObject[sp.id] = sp;
            })          
            this.meetingPropAndTypeArrays = resList[4];      
            resList[5].records.forEach(r => {
                let areaObjectArray = this.areaRelationObject[r.meetingProp];

                let areaObject = areaObjectArray.filter(a => a.areaDbId == r.areaDbId)[0];
                if(!areaObject) {
                    areaObject = {
                        areaDbId: r.areaDbId,
                        areaName: r.areaName,
                        productArray: []
                    }
                    areaObjectArray.push(areaObject)
                }

                let productObject = areaObject.productArray.filter(p => p.productDbId == r.productDbId)[0];
                if(!productObject) {
                    productObject = {
                        productDbId: r.productDbId,
                        productName: r.productName
                    }
                    areaObject.productArray.push(productObject)
                }
            });    
            this.init();    
        })
  }
};
</script>

<style lang="less" scoped>
    .more-tab-block {
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .field-block-no-top-margin {
        margin-top: 0px !important;
    }
    .field-block {
        font-size: @subSubFontSize;
        color: @subSubFontColor;
        padding-left: 15px;
        background-color: #fff;

        .more-tab {
            margin-right: 45px;
            border-left: 1px solid #E7E7E7;
            border-top: 1px solid #E7E7E7;
            border-right: 1px solid #E7E7E7;
            border-radius: 2px;
            position: relative;

            .field-row {
                padding-left: 15px;
            }
        }

        .more-tab.full {
            margin-right: 15px;
        }

        .more-tab + .more-tab, .more-tab + .more-tab-div {
            margin-top: 10px;
        }

        .field-title {
            height: 48px;
            line-height: 48px;
            background-color: #F2F4F8;
            margin-left: -15px;
            padding-left: 15px;

            span {
                display: none;
            }
        }

        .field-title.field-row-required {
            span {
                display: inline !important;
                color: #e64100;
                margin-left: 5px;
            }

            .field-input-no-title {
                span {                    
                    display: inline !important;
                    color: #e64100;
                    margin-left: 5px;
                }
            }
        }

        .field-row-required {
            .field-input-no-title {
                span {                    
                    display: inline !important;
                    color: #e64100;
                    margin-left: 5px;
                }
            }

            .field-input-no-title-tooltip {
                margin-left: 0px !important;
            }
        }

        .field-title.field-row-required.field-row-error + .field-row {
            border: 1px solid #e64100 !important;
        }

        .field-row.field-row-required.field-row-error  {
             border: 1px solid #e64100 !important;
        }

        .common-select {
        }

        .field-row-line {
            border-bottom: 1px solid #E7E7E7;;
        }

        .field-row-space {
            height: 10px;
        }
        
        .field-row {
            border-top: 1px solid #fff;
            border-bottom: 1px solid #E7E7E7;;
            background-color: #fff;
            min-height: 48px;
            position: relative;

            .recipientSociety-tooltip {
                position: absolute;
                top: 9px;
                left: 105px;
            }

            .field-input-no-title {
                display: initial;
                height: 48px;
                line-height: 48px;

                span {
                    display: none;
                }
            }

            .align-right.is-nolabel {
                display: inline-flex;
                float: right;
            }
        }

        .recipientSocietyOrHospital-text {
            height: auto;
            line-height: inherit;
            padding: 10px 15px;

            span{
                color: @mainColor;
                display: inline !important;
            }
        }
    }
    .field-block + .field-block {
        margin-top: 10px
    }
    .bottom-info {
        position: fixed;
        bottom: 0px;
        width: 375px;
        height: 61px;
        line-height: 44px;
        background: #ffffff;
        box-shadow: 0px -0.5px 0px 0px #e8eaec; 
        display: flex;
        font-size: 12px;
        border-bottom: 1px solid #e8eaec;

        button {
            margin: 10px auto;
        }
    }

    .operate-add-remove {
        display: flex;
        font-size: 20px;
        margin: 0 0px 0px 10px;
        position: absolute;
        right: -45px;
        top: 28px;

        .icon-tianjia1 {
            color: #0EC771;
        }
        .icon-shanjian {
            color: #FB304D;
        }

        i {
            cursor: pointer;
            height: 42px;
            line-height: 42px;
            margin-left: auto;
            padding-right: 15px;
        }

        i + i {
            margin-left: 5px;
        }
  }
</style>


// WEBPACK FOOTER //
// index.vue?64daade9